import {
	oultet,
	detOultet,
	pagination,
	filter,
	search,
} from "./state"

const mutations = {
	// mutate data outlet
	setOutlet(state, res) {
		// if (state.outlet.data !== undefined) {
		// 	state.outlet.data = [...state.outlet.data, ...res.data];
		// } else {
			state.outlet = res
		// }
	},
	setDetailOutlet(state, res){
		state.detailOultet = res
	},

	resetOutlet(state) {
		state.outlet = oultet()
	},
	resetDetailOutlet(state){
		state.detailOultet = detOultet()
	}
}

export default mutations